if (!customElements.get("variant-selects")) {
  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === "true";
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener("change", this.onVariantChange);
      this.other = Array.from(
        document.querySelectorAll("variant-selects")
      ).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest(".thb-product-detail");
      this.productSlider = this.productWrapper.querySelector(".product-images");
      this.hideVariants = this.dataset.hideVariants === "true";
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, "", false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, "", true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent("product:variant-change", {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector("select")) {
          this.options.push(fieldset.querySelector("select").value);
        } else if (fieldset.querySelectorAll("input").length) {
          this.options.push(fieldset.querySelector("input:checked").value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector(".form__label__value");
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === "false") {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll("fieldset"),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector("select")) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll("input").length) {
            fieldsets_array[i].querySelector(
              `input[value='${option}']`
            ).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector(
        ".product-thumbnail-container"
      );

      this.setActiveMedia(
        `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        this.productSlider,
        thumbnails
      );
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (
          productSlider.querySelector(
            ".product-images__slide.is-initial-selected"
          )
        ) {
          productSlider
            .querySelector(".product-images__slide.is-initial-selected")
            .classList.remove("is-initial-selected");
        }
        [].forEach.call(
          productSlider.querySelectorAll(
            ".product-images__slide-item--variant"
          ),
          function (el) {
            el.classList.remove("is-active");
          }
        );
        if (this.thumbnails) {
          if (
            this.thumbnails.querySelector(
              ".product-thumbnail.is-initial-selected"
            )
          ) {
            this.thumbnails
              .querySelector(".product-thumbnail.is-initial-selected")
              .classList.remove("is-initial-selected");
          }
          [].forEach.call(
            this.thumbnails.querySelectorAll(
              ".product-images__slide-item--variant"
            ),
            function (el) {
              el.classList.remove("is-active");
            }
          );
        }

        activeMedia.classList.add("is-active");
        activeMedia.classList.add("is-initial-selected");

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          activeThumb.classList.add("is-active");
          activeThumb.classList.add("is-initial-selected");
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);
      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateShareUrl() {
      const shareButton = document.getElementById(
        `Share-${this.dataset.section}`
      );
      if (!shareButton) return;
      shareButton.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment`
      );
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector(
        ".pickup-availability-wrapper"
      );

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute("available");
        pickUpAvailability.innerHTML = "";
      }
    }

    removeErrorMessage() {
      const section = this.closest("section");
      if (!section) return;

      const productForm = section.querySelector("product-form");
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [
        `price-${this.dataset.section}`,
        `price-${this.dataset.section}--sticky`,
        `product-image-${this.dataset.section}--sticky`,
        `inventory-${this.dataset.section}`,
        `sku-${this.dataset.section}`,
        `quantity-${this.dataset.section}`,
        `footer-specs-wrapper-${this.dataset.section}`,
          `alternative-product-${this.dataset.section}`,
      ];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + "--sticky");

            if (price) price.classList.remove("visibility-hidden");
            if (price_fixed) price_fixed.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut
          );
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(
        `product-form-${this.dataset.section}`
      );
      if (!productForm) return;

      const productTemplate = productForm
        .closest(".product-form")
        .getAttribute("template");
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute("disabled", "disabled");
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute("disabled");
          submitButton.classList.remove("loading");

          if (productTemplate?.includes("pre-order")) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent =
              window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll(
        ".single-add-to-cart-button"
      );
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(
        `price-${this.dataset.section}--sticky`
      );

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector(
          ".single-add-to-cart-button--text"
        );
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add("sold-out");
      });
      if (price) price.classList.add("visibility-hidden");
      if (price_fixed) price_fixed.classList.add("visibility-hidden");
    }

    setDisabled() {
      if (this.isDisabledFeature != "true") {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`,
            };
          });
        } else {
          let found_option = variant_data.find((option) => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                value: this.options[0],
                index: "option1",
              },
              {
                value: found_option.option2,
                index: "option2",
              },
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(
          variant_data,
          selected_options
        );

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector("select")) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = true;
                } else {
                  fieldset.querySelector(
                    "option[value=" + JSON.stringify(option.value) + "]"
                  ).disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll("input").length) {
              fieldset.querySelectorAll("input").forEach((input, input_i) => {
                input.classList.toggle(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable
                );
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/-$/, "")
        .replace(/^-/, "");
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector("[data-set-name]");
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector(
          '.product-form__input[data-handle="' + this.imageSetName + '"]'
        ).dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(
        this.currentVariant[this.imageSetIndex]
      );
      let group = this.imageSetName + "_" + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(
          `.product-images__slide[data-set-name="${this.imageSetName}"]`
        ),
        selected_set_thumbs = this.productWrapper.querySelectorAll(
          `.product-thumbnail[data-set-name="${this.imageSetName}"]`
        );

      if (this.hideVariants) {
        // Product images
        this.productWrapper
          .querySelectorAll(".product-images__slide")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_images.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper
          .querySelectorAll(".product-thumbnail")
          .forEach((thumb) => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove("is-active");
            }
          });
        selected_set_thumbs.forEach((thumb) => {
          thumb.classList.toggle("is-active", thumb.dataset.group === group);
        });
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce(
        (options, variant) => {
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach((index) => {
            if (variant[index] === null) return;

            let entry = options[index].find(
              (option) => option.value === variant[index]
            );

            if (typeof entry === "undefined") {
              // If option has yet to be added to the options tree, add it
              entry = { value: variant[index], isUnavailable: true };
              options[index].push(entry);
            }

            const currentOption1 = currentlySelectedValues.find(
              ({ value, index }) => index === "option1"
            );
            const currentOption2 = currentlySelectedValues.find(
              ({ value, index }) => index === "option2"
            );

            switch (index) {
              case "option1":
                // Option1 inputs should always remain enabled based on all available variants
                entry.isUnavailable =
                  entry.isUnavailable && variant.available
                    ? false
                    : entry.isUnavailable;
                break;
              case "option2":
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (
                  currentOption1 &&
                  variant.option1 === currentOption1.value
                ) {
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available
                      ? false
                      : entry.isUnavailable;
                }
                break;
              case "option3":
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 &&
                  variant.option1 === currentOption1.value &&
                  currentOption2 &&
                  variant.option2 === currentOption2.value
                ) {
                  entry.isUnavailable =
                    entry.isUnavailable && variant.available
                      ? false
                      : entry.isUnavailable;
                }
            }
          });

          return options;
        },
        { option1: [], option2: [], option3: [] }
      );
    }

    getVariantData() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define("variant-selects", VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value;
      });
    }
  }

  customElements.define("variant-radios", VariantRadios);
}

if (!customElements.get("product-slider")) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("change", this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest(".thb-product-detail");
      this.thumbnail_container = this.product_container.querySelector(
        ".product-thumbnail-container"
      );
      this.video_containers = this.querySelectorAll(
        ".product-single__media-external-video--play"
      );

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == "true";
      this.thumbnails =
        this.thumbnail_container.querySelectorAll(".product-thumbnail");
      this.prev_button = this.querySelector(".flickity-prev");
      this.next_button = this.querySelector(".flickity-next");
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: ".is-initial-selected",
        prevNextButtons: false,
        fade: false,
        cellSelector: ".product-images__slide.is-active",
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener("click", (event) => {
          this.flkty.previous();
        });
        prev.addEventListener("keyup", (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener("click", (event) => {
          this.flkty.next();
        });
        next.addEventListener("keyup", (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container
          .querySelector("button")
          .addEventListener("click", function () {
            container.setAttribute("hidden", "");
          });
      });
      this.flkty.on("settle", function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on("change", (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector(
            ".product-single__media"
          ),
          active_thumbs = Array.from(this.thumbnails).filter((element) =>
            element.classList.contains("is-active")
          ),
          active_thumb = active_thumbs[index]
            ? active_thumbs[index]
            : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove("is-initial-selected");
        });
        active_thumb.classList.add("is-initial-selected");

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left:
              active_thumb.offsetLeft -
              windowHalfWidth +
              active_thumb.clientWidth / 2,
            top:
              active_thumb.offsetTop -
              windowHalfHeight +
              active_thumb.clientHeight / 2,
            behavior: "smooth",
          });
        });

        // Stop previous video
        if (
          previous_media.classList.contains(
            "product-single__media-external-video"
          )
        ) {
          if (previous_media.dataset.provider === "youtube") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                event: "command",
                func: "pauseVideo",
                args: "",
              }),
              "*"
            );
          } else if (previous_media.dataset.provider === "vimeo") {
            previous_media.querySelector("iframe").contentWindow.postMessage(
              JSON.stringify({
                method: "pause",
              }),
              "*"
            );
          }
          previous_media
            .querySelector(".product-single__media-external-video--play")
            .removeAttribute("hidden");
        } else if (
          previous_media.classList.contains(
            "product-single__media-native-video"
          )
        ) {
          previous_media.querySelector("video").pause();
        }
      });

      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(
          (element) => element.clientWidth > 0
        );
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove("is-initial-selected");
      });
      thumbnail.classList.add("is-initial-selected");
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll(".product-single__media-zoom").length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(
        this.querySelectorAll(
          ".product-images__slide.is-active .product-single__media-image"
        )
      );

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(
          item.parentNode.parentNode.children,
          item.parentNode
        );

        let activelink = item.querySelector(".product-single__media-zoom");

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute("href"),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll(".product-single__media-zoom");
      this.pswpElement = document.querySelectorAll(".pswp")[0];

      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector(
              ".product-images__slide.is-selected"
            ),
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width,
          };
        },
      };

      this.links.forEach((link) => {
        link.addEventListener("click", (e) => this.zoomClick(e, link));
      });
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== "undefined") {
        let pswp = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI_Default,
          this.items,
          this.pswpOptions
        );
        document.body.classList.add("open-lightbox");
        pswp.listen("firstUpdate", function () {
          pswp.listen("destroy", function () {
            document.body.classList.remove("open-lightbox");
          });
          pswp.listen("parseVerticalMargin", function (item) {
            item.vGap = {
              top: 50,
              bottom: 50,
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define("product-slider", ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.sticky = this.dataset.sticky;
        this.form = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        this.form.querySelector("[name=id]").disabled = false;
        if (!this.sticky) {
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector("cart-notification");
        this.body = document.body;

        this.hideErrors = this.dataset.hideErrors === "true";

        // Setup addon select change handlers
        this.setupAddonHandlers();
      }

      setupAddonHandlers() {
        console.log("Setting up addon handlers...");
        let addonSelects = this.form.querySelectorAll(".addon-select");
        console.log("Found addon selects in form:", addonSelects.length);

        // If no selects found in form, try globally
        if (addonSelects.length === 0) {
          addonSelects = document.querySelectorAll(".addon-select");
          console.log("Found addon selects globally:", addonSelects.length);
        }

        addonSelects.forEach((select) => {
          const addonId = select.dataset.addonId;

          // Initialize dimensions input visibility based on current selection
          let dimensionsInput = this.form.querySelector(
            `input[name="properties[_addon_${addonId}_dimensions]"]`
          );

          if (!dimensionsInput) {
            // If not found in form, search globally
            dimensionsInput = document.querySelector(
              `input[name="properties[_addon_${addonId}_dimensions]"]`
            );
          }

          if (dimensionsInput) {
            // Check if value contains "Ja" (Dutch for Yes) or starts with "Ja"
            const isCurrentlySelected =
              select.value.includes("Ja") || select.value.startsWith("Ja");
            console.log(
              `Initializing addon ${addonId}: value="${select.value}", selected=${isCurrentlySelected}`
            );
            dimensionsInput.style.display = isCurrentlySelected
              ? "block"
              : "none";
            if (!isCurrentlySelected) {
              dimensionsInput.value = "";
            }
          } else {
            console.log(
              `Could not find dimensions input for addon ${addonId} during initialization`
            );
          }

          // Add event listener for changes
          select.addEventListener("change", (e) => {
            // Check if value contains "Ja" (Dutch for Yes) or starts with "Ja"
            const isSelected =
              e.target.value.includes("Ja") || e.target.value.startsWith("Ja");
            console.log(
              `Addon ${addonId} changed to: "${e.target.value}", selected=${isSelected}`
            );

            if (dimensionsInput) {
              dimensionsInput.style.display = isSelected ? "block" : "none";
              console.log(
                `Setting dimensions input display to: ${
                  isSelected ? "block" : "none"
                }`
              );
              if (!isSelected) {
                dimensionsInput.value = "";
              }
            } else {
              console.log(
                `Could not find dimensions input for addon ${addonId}`
              );
            }

            // Update total price when addon selection changes
            updateTotalPrice();
          });
        });
      }
      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.form.reportValidity()) {
          return;
        }

        const submitButtons = document.querySelectorAll(
          ".single-add-to-cart-button"
        );

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains("loading")) return;
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        this.handleErrorMessage();

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
        };

        // Check if addon is selected and prepare items array
        const cartItems = await this.prepareCartItems();

        // Use JSON API for multiple items
        const config2 = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };

        const body = {
          items: cartItems,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        };

        config2.body = JSON.stringify(body);

        fetch(`${theme.routes.cart_add_url}`, config2)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              dispatchCustomEvent("product:variant-error", {
                source: "product-form",
                productVariantId: cartItems[0]?.id,
                errors: response.description,
                message: response.message,
              });
              if (response.status === 422) {
                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: true,
                  })
                );
              }
              this.handleErrorMessage(response.description);
              return;
            }

            this.renderContents(response);

            dispatchCustomEvent("cart:item-added", {
              product: response.hasOwnProperty("items")
                ? response.items[0]
                : response,
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
          });
      }

      async prepareCartItems() {
        const formData = new FormData(this.form);
        const cartItems = [];

        // Main product item
        const mainItem = {
          id: parseInt(formData.get("id")),
          quantity: parseInt(formData.get("quantity")) || 1,
          properties: {},
        };

        // Add all form properties to main item
        for (const [key, value] of formData.entries()) {
          if (key.startsWith("properties[")) {
            const propName = key.replace("properties[", "").replace("]", "");
            mainItem.properties[propName] = value;
          }
        }

        cartItems.push(mainItem);

        // Check for addon selection
        const addonSelects = document.querySelectorAll(
          ".addon-select[data-addon-sku]"
        );

        for (const select of addonSelects) {
          const selectedOption = select.options[select.selectedIndex];
          const isAddonSelected =
            selectedOption && selectedOption.dataset.addonOption === "yes";

          if (isAddonSelected) {
            const addonSku = select.dataset.addonSku;

            try {
              const addonVariant = await findVariantBySku(addonSku);
              if (addonVariant) {
                const addonItem = {
                  id: addonVariant.id,
                  quantity: mainItem.quantity, // Same quantity as main product
                  properties: {
                    _addon_service: "Jaarlijkse keuring",
                    _related_to: `Product ID: ${mainItem.id}`,
                  },
                };
                cartItems.push(addonItem);
              } else {
                console.warn(`Addon product ${addonSku} not found`);
              }
            } catch (error) {
              console.error("Error finding addon:", error);
            }
          }
        }

        return cartItems;
      }

      // Keep this method for fallback purposes
      async handleAddonProduct(formData) {
        console.log("🔧 handleAddonProduct called");

        // Check if any addon is selected
        const addonSelects = document.querySelectorAll(
          ".addon-select[data-addon-sku]"
        );
        console.log("🔍 Found addon selects:", addonSelects.length);

        for (const select of addonSelects) {
          const selectedOption = select.options[select.selectedIndex];
          const isAddonSelected =
            selectedOption && selectedOption.dataset.addonOption === "yes";

          console.log("🎯 Addon check:", {
            value: select.value,
            hasYesOption: !!selectedOption?.dataset.addonOption,
            isSelected: isAddonSelected,
            sku: select.dataset.addonSku,
          });

          if (isAddonSelected) {
            const addonSku = select.dataset.addonSku;
            const quantity = parseInt(formData.get("quantity")) || 1;

            console.log(
              `Adding addon product with SKU: ${addonSku}, quantity: ${quantity}`
            );

            try {
              // Find addon product by SKU
              const addonVariant = await this.findVariantBySku(addonSku);
              if (addonVariant) {
                console.log("Found addon variant:", addonVariant);
                await this.addAddonToCart(addonVariant.id, quantity);
              } else {
                console.warn(`Addon product with SKU ${addonSku} not found`);

                // Fallback: If you know the specific variant ID for SERVICE-CUT, use it here
                // For now, let's try a hardcoded approach as backup
                console.log(
                  "Trying fallback method to find SERVICE-CUT product..."
                );
                await this.tryFallbackAddonAdd(quantity);
              }
            } catch (error) {
              console.error("Error adding addon product:", error);
            }
          } else {
            console.log("Addon not selected or not yes option");
          }
        }
      }

      async findVariantBySku(sku) {
        console.log(`Searching for variant with SKU: ${sku}`);

        try {
          // Try using products.json API to find all products
          const productsUrl = `/products.json?limit=250`;
          console.log(`Trying products API: ${productsUrl}`);

          const response = await fetch(productsUrl);
          console.log(`Products response status: ${response.status}`);

          if (!response.ok) {
            throw new Error(`Products API failed: ${response.status}`);
          }

          const data = await response.json();
          console.log("Products API response:", data);

          if (data.products && data.products.length > 0) {
            // Search through all products for matching SKU
            for (const product of data.products) {
              for (const variant of product.variants) {
                if (variant.sku === sku) {
                  console.log("Found matching variant:", variant);
                  return variant;
                }
              }
            }
          }

          console.log("No variant found with SKU:", sku);
          return null;
        } catch (error) {
          console.error("Error finding product by SKU:", error);
          return null;
        }
      }

      async tryFallbackAddonAdd(quantity) {
        // If you know the exact variant ID of SERVICE-CUT product, add it here
        // You can find this in Shopify admin or by checking the product page

        console.log(
          "Fallback: Trying to find SERVICE-CUT through individual product check"
        );

        // Another approach: try to find if there's a product handle like 'service-cut'
        try {
          const productHandle = "service-cut"; // or whatever the handle is
          const productUrl = `/products/${productHandle}.js`;
          console.log(`Trying product handle: ${productUrl}`);

          const response = await fetch(productUrl);
          if (response.ok) {
            const product = await response.json();
            console.log("Found product by handle:", product);

            // Find variant with SERVICE-CUT SKU
            const variant = product.variants.find(
              (v) => v.sku === "SERVICE-CUT"
            );
            if (variant) {
              console.log("Found SERVICE-CUT variant via fallback:", variant);
              await this.addAddonToCart(variant.id, quantity);
              return;
            }
          }
        } catch (error) {
          console.log("Fallback method also failed:", error);
        }

        console.warn("Could not find SERVICE-CUT product through any method");
      }

      async addAddonToCart(variantId, quantity) {
        console.log(
          `Adding addon to cart - variant ID: ${variantId}, quantity: ${quantity}`
        );

        const config = {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        };

        const body = {
          items: [
            {
              id: variantId,
              quantity: quantity,
              properties: {
                _addon_service: "Jaarlijkse keuring",
              },
            },
          ],
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        };

        console.log("Request body:", body);
        config.body = JSON.stringify(body);

        try {
          console.log("Sending request to:", theme.routes.cart_add_url);
          const response = await fetch(`${theme.routes.cart_add_url}`, config);
          console.log("Addon cart response status:", response.status);

          const result = await response.json();
          console.log("Addon cart response:", result);

          if (result.status) {
            console.error("❌ Error adding addon to cart:", result);
          } else {
            console.log("✅ Addon product added successfully to cart");
            console.log("📦 Added items:", result.items);
            console.log("🔄 Sections returned:", result.sections);

            // Update cart sections if returned
            if (result.sections) {
              console.log("🖼️ Updating cart sections...");
              this.renderContents(result);
            }

            // Trigger cart refresh to update UI
            console.log("🔄 Triggering cart refresh...");
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
              })
            );

            // Alternative: force reload cart sections
            setTimeout(async () => {
              console.log("🔄 Alternative cart refresh...");
              try {
                const cartResponse = await fetch(
                  "/cart?section_id=cart-drawer"
                );
                if (cartResponse.ok) {
                  const cartHtml = await cartResponse.text();
                  const cartDrawer = document.querySelector("cart-drawer");
                  if (cartDrawer) {
                    cartDrawer.innerHTML = cartHtml;
                  }
                }
              } catch (error) {
                console.log("Cart refresh failed:", error);
              }
            }, 200);

            // Also dispatch cart item added event for consistency
            if (result.items && result.items[0]) {
              dispatchCustomEvent("cart:item-added", {
                product: result.items[0],
              });
            }

            // Force cart counter update
            setTimeout(() => {
              const cartCounters = document.querySelectorAll(
                ".cart-count, .thb-item-count, [data-cart-count]"
              );
              cartCounters.forEach((counter) => {
                const currentCount = parseInt(counter.textContent) || 0;
                counter.textContent = currentCount + quantity;
              });
            }, 100);
          }
        } catch (error) {
          console.error("Error adding addon to cart:", error);
        }
      }

      getSectionsToRender() {
        return [
          {
            id: "Cart",
            section: "main-cart",
            selector: ".thb-cart-form",
          },
          {
            id: "Cart-Drawer",
            section: "cart-drawer",
            selector: ".cart-drawer",
          },
          {
            id: "cart-drawer-toggle",
            section: "cart-bubble",
            selector: ".thb-item-count",
          },
        ];
      }
      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          if (!document.getElementById(section.id)) {
            return;
          }
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );

          if (section.id === "Cart-Drawer") {
            document.getElementById("Cart-Drawer")?.removeProductEvent();
          }
          if (typeof Cart !== "undefined") {
            new Cart().renderContents(parsedState);
          }
        });

        let product_drawer = document.getElementById("Product-Drawer"),
          search_drawer = document.getElementById("Search-Drawer");

        if (search_drawer.classList.contains("active")) {
          search_drawer.classList.remove("active");
        }
        if (product_drawer && product_drawer.contains(this)) {
          product_drawer.classList.remove("active");
          this.body.classList.remove("open-cc--product");
          if (document.getElementById("Cart-Drawer")) {
            document.getElementById("Cart-Drawer").open();
          }
        } else if (document.getElementById("Cart-Drawer")) {
          document.getElementById("Cart-Drawer").open();
        }
      }
      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get("product-add-to-cart-sticky")) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
    }
    connectedCallback() {
      if (!this.hasAttribute("data-moved-to-body")) {
    this.setAttribute("data-moved-to-body", "true");
    document.body.appendChild(this);
    return;
  }
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector(".product-add-to-cart-sticky--inner"),
        content = this.querySelector(".product-add-to-cart-sticky--content");

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: false,
          paused: true,
          onStart: () => {
            button.classList.add("sticky-open");
          },
          onReverseComplete: () => {
            button.classList.remove("sticky-open");
          },
        });

        tl.set(
          content,
          {
            display: "block",
            height: "auto",
          },
          "start"
        ).from(
          content,
          {
            height: 0,
            duration: 0.25,
          },
          "start+=0.001"
        );
tl.play(0);
        button.addEventListener("click", function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener("click", function () {
          content.classList.toggle("active");
          return false;
        });
      }
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  _this.classList.remove("sticky--visible");
                } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                  _this.classList.add("sticky--visible");
                }
              }
              if (entry.target === form) {
                let boundingRect = form.getBoundingClientRect();

                if (
                  entry.intersectionRatio === 0 &&
                  window.scrollY > boundingRect.top + boundingRect.height
                ) {
                  _this.formPassed = true;
                  _this.classList.add("sticky--visible");
                } else if (entry.intersectionRatio === 1) {
                  _this.formPassed = false;
                  _this.classList.remove("sticky--visible");
                }
              }
            });
          },
          {
            threshold: [0, 1],
          }
        ),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById("footer");
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define("product-add-to-cart-sticky", ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get("side-panel-links")) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll("button");
      this.drawer = document.getElementById("Product-Information-Drawer");
      this.buttons = this.drawer.querySelector(".side-panel-content--tabs");
      this.panels = this.drawer
        .querySelector(".side-panel-content--inner")
        .querySelectorAll(".side-panel-content--tab-panel");
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {}
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener("click", (e) => {
          this.body.classList.add("open-cc");
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add("active");
        });
      });
    }
  }

  customElements.define("side-panel-links", ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

/**
 * Area calculation functionality for quantity selector
 * Simple and clean implementation
 */
document.addEventListener("DOMContentLoaded", function () {
  initAreaCalculation();
});

function initAreaCalculation() {
  // Find all quantity inputs with area calculation
  const quantityInputs = document.querySelectorAll(
    ".quantity__input[data-area-per-package]"
  );

  quantityInputs.forEach((quantityInput) => {
    setupQuantityAreaSync(quantityInput);
  });

  // Watch for new elements added to DOM (variant changes, etc.)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          const newQuantityInputs = node.querySelectorAll
            ? node.querySelectorAll(".quantity__input[data-area-per-package]")
            : [];
          newQuantityInputs.forEach((input) => {
            if (!input.hasAttribute("data-area-sync-setup")) {
              setupQuantityAreaSync(input);
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function setupQuantityAreaSync(quantityInput) {
  const sectionId = quantityInput.id.replace("Quantity-", "");
  const areaInput = document.getElementById(`area-${sectionId}`);

  if (!areaInput) return;

  // Mark as setup to avoid duplicates
  quantityInput.setAttribute("data-area-sync-setup", "true");

  // Setup quantity input listeners
  quantityInput.addEventListener("input", () => {
    updateAreaFromQuantity(quantityInput, areaInput);
    updateTotalPrice();
  });

  quantityInput.addEventListener("change", () => {
    updateAreaFromQuantity(quantityInput, areaInput);
    updateTotalPrice();
  });

  // Setup area input listeners
  areaInput.addEventListener("input", () => {
    updateQuantityFromArea(areaInput, quantityInput);
    updateTotalPrice();
  });

  areaInput.addEventListener("change", () => {
    updateQuantityFromArea(areaInput, quantityInput);
    updateTotalPrice();
  });

  // Restrict area input to numbers only
  areaInput.addEventListener("keypress", (e) => {
    const char = String.fromCharCode(e.which);
    if (!/[0-9.]/.test(char)) {
      e.preventDefault();
    }
  });

  areaInput.addEventListener("paste", (e) => {
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    if (!/^[0-9.]*$/.test(paste)) {
      e.preventDefault();
    }
  });

  // Initial calculation
  updateAreaFromQuantity(quantityInput, areaInput);
}

function updateAreaFromQuantity(quantityInput, areaInput) {
  const quantity = parseInt(quantityInput.value) || 0;
  const areaPerPackage = parseFloat(quantityInput.dataset.areaPerPackage) || 1;
  const totalArea = quantity * areaPerPackage;

  if (areaInput.tagName === "INPUT") {
    areaInput.value = totalArea.toFixed(2);
  } else {
    areaInput.textContent = `${totalArea.toFixed(2)} m²`;
  }
}

function updateQuantityFromArea(areaInput, quantityInput) {
  const totalArea = parseFloat(areaInput.value) || 0;
  const areaPerPackage = parseFloat(quantityInput.dataset.areaPerPackage) || 1;

  // Round up to the next integer (ceiling)
  const calculatedQuantity = Math.ceil(totalArea / areaPerPackage);

  quantityInput.value = calculatedQuantity;
}

function updateTotalPrice() {
  // Get current variant price
  const variantSelects = document.querySelector("variant-selects");
  if (!variantSelects || !variantSelects.currentVariant) return;

  const basePrice = variantSelects.currentVariant.price;
  const compareAtPrice = variantSelects.currentVariant.compare_at_price;
  const isTaxable = variantSelects.currentVariant.taxable;
  const sectionId = variantSelects.dataset.section;

  // Get quantity for this specific product
  const quantityInput = document.querySelector(`#Quantity-${sectionId}`);
  const quantity = parseInt(quantityInput?.value) || 1;

  // Calculate addon price if selected
  let addonPrice = 0;
  const addonSelects = document.querySelectorAll(
    ".addon-select[data-addon-base-price]"
  );

  addonSelects.forEach((select) => {
    const selectedOption = select.options[select.selectedIndex];
    if (selectedOption && selectedOption.dataset.addonOption === "yes") {
      const baseAddonPrice = parseFloat(select.dataset.addonBasePrice) || 0;
      // baseAddonPrice is now in cents from actual product price
      addonPrice += baseAddonPrice * quantity;
    }
  });

  // Calculate total prices including addon
  const totalPrice = basePrice * quantity + addonPrice;
  const totalCompareAtPrice = compareAtPrice ? compareAtPrice * quantity : null;

  // Update regular price display
  const priceElements = document.querySelectorAll(
  `#price-${sectionId} [data-price-incl-tax]`
);
priceElements.forEach((element) => {
  const formattedPriceExcl = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
  }).format((isTaxable ? totalPrice / 1.21 : totalPrice) / 100);

  const formattedPriceIncl = new Intl.NumberFormat("nl-NL", {
  style: "currency",
  currency: "EUR",
  }).format((isTaxable ? totalPrice : totalPrice * 1.21) / 100);

  element.textContent = formattedPriceExcl;
  element.setAttribute("data-price-excl-tax", formattedPriceExcl);
  element.setAttribute("data-price-incl-tax", formattedPriceIncl);
});

  // Update compare at price (crossed out price) if it exists
if (totalCompareAtPrice && totalCompareAtPrice > totalPrice) {
  const compareAtElements = document.querySelectorAll(
    `#price-${sectionId} del .amount`
  );
  compareAtElements.forEach((element) => {
    const formattedComparePriceExcl = new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR",
    }).format((isTaxable ? totalCompareAtPrice / 1.21 : totalCompareAtPrice) / 100);

    const formattedComparePriceIncl = new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: "EUR",
    }).format((isTaxable ? totalCompareAtPrice : totalCompareAtPrice * 1.21) / 100);

    element.textContent = formattedComparePriceExcl;
    element.setAttribute("data-price-excl-tax", formattedComparePriceExcl);
    element.setAttribute("data-price-incl-tax", formattedComparePriceIncl);
  });
}

  // Update addon prices in option text
  updateAddonPricesDisplay(quantity);
}

async function updateAddonPricesDisplay(quantity = 1) {
  // Find all addon selects and update their price display in options
  const addonSelects = document.querySelectorAll(
    ".addon-select[data-addon-sku]"
  );

  for (const select of addonSelects) {
    const addonSku = select.dataset.addonSku;
    if (!addonSku) continue;

    try {
      // Get the actual price from the addon product
      const addonVariant = await findVariantBySku(addonSku);
      if (!addonVariant) continue;

      console.log("DEBUG - Addon variant:", addonVariant);
      console.log("DEBUG - Raw price from API:", addonVariant.price);

      const basePrice = addonVariant.price; // Price in euros (not cents!)
      const totalAddonPrice = basePrice * quantity;

      // Format the price (no need to divide by 100)
      const formattedPrice = new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      }).format(totalAddonPrice);

      console.log("DEBUG - Formatted price:", formattedPrice);

      // Find the yes option and update its text and value
      const yesOption = select.querySelector('option[data-addon-option="yes"]');
      if (yesOption) {
        // Get the original text (without price) - split by opening parenthesis
        const optionText = yesOption.textContent.split("(+")[0].trim();

        // Update both the option text and value
        const newText = `${optionText} (+${formattedPrice})`;
        yesOption.textContent = newText;

        // Also update the value to include the new price
        const baseValue = yesOption.value.split("(+")[0];
        yesOption.value = `${baseValue} (+${formattedPrice})`;
      }

      // Update the data attribute for price calculations (convert to cents)
      select.dataset.addonBasePrice = (basePrice * 100).toString();
    } catch (error) {
      console.error(`Error updating addon price for ${addonSku}:`, error);
    }
  }
}

// Global function to find variant by SKU
async function findVariantBySku(sku) {
  try {
    // Try using products.json API to find all products
    const productsUrl = `/products.json?limit=250`;

    const response = await fetch(productsUrl);
    if (!response.ok) {
      throw new Error(`Products API failed: ${response.status}`);
    }

    const data = await response.json();
    if (data.products && data.products.length > 0) {
      // Search through all products for matching SKU
      for (const product of data.products) {
        for (const variant of product.variants) {
          if (variant.sku === sku) {
            return variant;
          }
        }
      }
    }

    return null;
  } catch (error) {
    console.error("Error finding product by SKU:", error);
    return null;
  }
}

// Initialize total price calculation on page load
document.addEventListener("DOMContentLoaded", () => {
  // Wait for variant selects to be ready
  setTimeout(() => {
    updateTotalPrice();
    // Initialize addon prices display with actual prices
    updateAddonPricesDisplay(1);
  }, 100);
});
